import { LoyaltyRewardsReduxState } from 'types/store';
import {
  LoyaltyRewardsAction,
  SET_RLR_PAGE_MODEL,
  SET_RLR_JOURNEY_ERROR,
  SET_RLR_JOURNEY_REWARD,
  SET_RLR_VEHICLES,
  ADD_RLR_VEHICLE,
  SET_CHOSEN_VEHICLE,
  SET_VEHICLE_DISPLAY_MODALITY,
  SET_CLAIM_REWARD_RESPONSE,
} from 'actions/journeys/loyaltyRewardsActions';
import { RLRVehicleInfoEnum } from 'constants/journeys/loyaltyRewardsEnums';

const initialState: LoyaltyRewardsReduxState = {
  pageModel: null,
  journeyError: null,
  vehicles: [],
  vehicleDisplayModality: RLRVehicleInfoEnum.NoVehicleCapture,
  data: {
    selectedReward: null,
    chosenVehicle: null,
  },
  claimResponse: null,
};

function loyaltyRewardsReducer(state = initialState, action: LoyaltyRewardsAction) {
  switch (action.type) {
    case SET_RLR_PAGE_MODEL:
      return {
        ...state,
        pageModel: action.payload,
      };
    case SET_RLR_JOURNEY_ERROR:
      return {
        ...state,
        journeyError: action.payload,
      };
    case SET_RLR_JOURNEY_REWARD:
      return {
        ...state,
        data: {
          ...state.data,
          selectedReward: action.payload,
        },
      };
    case SET_RLR_VEHICLES:
      return {
        ...state,
        vehicles: action.payload,
      };
    case ADD_RLR_VEHICLE:
      return {
        ...state,
        vehicles: [
          ...state.vehicles,
          action.payload,
        ],
      };
    case SET_CHOSEN_VEHICLE:
      return {
        ...state,
        data: {
          ...state.data,
          chosenVehicle: action.payload,
        },
      };
    case SET_VEHICLE_DISPLAY_MODALITY:
      return {
        ...state,
        vehicleDisplayModality: action.payload,
      };
    case SET_CLAIM_REWARD_RESPONSE:
      return {
        ...state,
        claimResponse: action.payload,
      };
    default:
      return state;
  }
}

export { initialState, loyaltyRewardsReducer };
